"use client";

import {
  useWebSocketInternal,
  type WebSocketCallback,
  type WebSocketRequestMessageType,
} from "utils";
import { useAppConfiguration } from "appConfig";

export enum MediaBuilderContentType {
  ImageBuild = "ImageBuild",
  VideoBuild = "VideoBuild",
  Media = "Media",
}

interface MediaBuilderContentChangeProps {
  contentType: MediaBuilderContentType;
  id?: string;
  onMessageCallback: WebSocketCallback;
  onErrorCallback?: (event: any) => VoidFunction;
}

export function useWebSocketMediaBuilder({
  contentType,
  id,
  onMessageCallback,
  onErrorCallback,
}: MediaBuilderContentChangeProps) {
  const getRequest = (): WebSocketRequestMessageType => {
    if (id) {
      return {
        Subscribe: {
          ContentType: contentType,
          Id: id,
        },
      };
    } else {
      return {
        Subscribe: {
          ContentType: contentType,
        },
      };
    }
  };

  const appConfiguration = useAppConfiguration();

  // the configuration is resolved asynchronously and starts out empty; without this guard
  // the first attempt would connect to a relative "/api/ws", which the browser resolves
  // against the dashboard host instead of the media builder one
  const url = appConfiguration.mediaBuilderApiUrl
    ? `${appConfiguration.mediaBuilderApiUrl}/api/ws`
    : "";

  return useWebSocketInternal(
    url,
    getRequest,
    onMessageCallback,
    onErrorCallback
  );
}
